import { Navigate, createBrowserRouter } from "react-router-dom";

/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import Login from "./modules/admin/pages/login";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
import Profile from "./modules/admin/pages/profile";
import EditProfile from "./modules/admin/pages/editprofile";
import Changepassword from "./modules/admin/pages/changepassword";
import OtpVerificationPage from "./modules/admin/pages/otpverification";
import ForgotPwdPage from "./modules/admin/pages/forgotpassword";
import ResetPwdPage from "./modules/admin/pages/resetpwd";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageView from "./modules/admin/pages/cms/pages/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";

import BannerTable from "./modules/admin/pages/cms/banners/list";
import BannerAdd from "./modules/admin/pages/cms/banners/add";
import BannerEdit from "./modules/admin/pages/cms/banners/edit";
import BannerView from "./modules/admin/pages/cms/banners/view";

import CategoryTable from "./modules/admin/pages/manage-categories/categories/list";

import CompleteAdminProfile from "./modules/admin/pages/completeAdminProfile";

import InvoiceDesign from "./modules/admin/pages/invoiceDesign";
import TestimonialTable from "./modules/admin/pages/testimonial/list";
import TestimonialAdd from "./modules/admin/pages/testimonial/add";
import TestimonialView from "./modules/admin/pages/testimonial/view";
import TestimonialEdit from "./modules/admin/pages/testimonial/edit";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";
import WebsiteLayout from "./modules/website/shared/layout";
import WebsiteHomePage from "./modules/website/pages/homePage";
import FAQAdd from "./modules/admin/pages/cms/faq/add";
import FAQEdit from "./modules/admin/pages/cms/faq/edit";
import FAQTable from "./modules/admin/pages/cms/faq/list";
import FAQView from "./modules/admin/pages/cms/faq/view";
import CategoriesAdd from "./modules/admin/pages/manage-categories/categories/add";
import CategoriesEdit from "./modules/admin/pages/manage-categories/categories/edit";
import CategoriesView from "./modules/admin/pages/manage-categories/categories/view";
import InquiryTable from "./modules/admin/pages/inquiry/list";
import InquiryView from "./modules/admin/pages/inquiry/view";
import BusinessPrivateRoute from "./modules/business/shared/businessPrivateRoute";
import BusinessPublicRoute from "./modules/business/shared/publicRoute";
import BusinessAuthLayout from "./modules/business/shared/businessAuthLayout";
import BusinessLayout from "./modules/business/shared/businessLayout";
import BusinessLogin from "./modules/business/pages/auth/login";
import BusinessForgotPwdPage from "./modules/business/pages/auth/forgot_password";
import BusinessVerifyOTP from "./modules/business/pages/auth/verifyotp";
import BusinessSupport from "./modules/business/pages/support/support";
import BusinessResetPassword from "./modules/business/pages/auth/resetPassword";
import BusinessRegister from "./modules/business/pages/auth/register";
import BusinessRegisterVerifyOTP from "./modules/business/pages/auth/verifyOTPRegister";
import BusinessThanksPage from "./modules/business/pages/auth/thanksPage";
import PasswordUpdatePage from "./modules/business/pages/auth/passwordUpdatePage";
import { ProfileFormProvider } from "./modules/business/pages/hooks/complete-profile";
import LocationDetail from "./modules/business/pages/complete-profile/location-details";
import BusinessDescription from "./modules/business/pages/complete-profile/business-description";
import OpeningHours from "./modules/business/pages/complete-profile/opening-hours";
import BusinessDashboard from "./modules/business/pages/dashboard/BusinessDashboard";

import SubCategoryTable from "./modules/admin/pages/manage-categories/sub-categories/list";
import SubCategoriesAdd from "./modules/admin/pages/manage-categories/sub-categories/add";
import SubCategoriesEdit from "./modules/admin/pages/manage-categories/sub-categories/edit";
import SubCategoriesView from "./modules/admin/pages/manage-categories/sub-categories/view";
import AccountSetting from "./modules/business/pages/accountSetting/setting";
import ChangePassword from "./modules/business/pages/accountSetting/change-password";
import BusinessList from "./modules/admin/pages/business/list";
import BusinessView from "./modules/admin/pages/business/view";
import StripeHome from "./modules/business/pages/complete-profile/stripeHome";
import BusinessWelcomePage from "./modules/business/pages/auth/welcome";
import BusinessProfileLayout from "./modules/business/shared/businessProfileLayout";
import UsersList from "./modules/admin/pages/user/list";
import UserView from "./modules/admin/pages/user/view";
import Page404 from "./modules/business/pages/dashboard/404page";
import BusinessTermsAndConditions from "./modules/business/pages/auth/businessTermsAndConditions";
import BusinessEdit from "./modules/admin/pages/business/edit";
import UserEdit from "./modules/admin/pages/user/edit";
import FAQ from "./modules/business/pages/support/faq";
import CustomerTicket from "./modules/business/pages/support/ticket";
import EditBusinessInfo from "./modules/business/pages/accountSetting/edit-business-info";
import EditBusinessDescription from "./modules/business/pages/accountSetting/edit-business-description";
import EditBusinessHours from "./modules/business/pages/accountSetting/edit-business-hours";
import EditNotification from "./modules/business/pages/accountSetting/edit-notification";
import PrivacyPolicy from "./modules/business/pages/auth/privacy-policy";
import BusinessTransactions from "./modules/business/pages/transactions/transaction";
import BusinessTransactionDetails from "./modules/business/pages/transactions/transaction-details";
import EditLocationDetails from "./modules/business/pages/accountSetting/edit-location-details";
import TransactionsList from "./modules/admin/pages/transactions/list";
import BusinessCoupons from "./modules/business/pages/coupons/add";
import ListBusinessCoupons from "./modules/business/pages/coupons/list";
import ViewBusinessCoupon from "./modules/business/pages/coupons/view";
import EditBusinessCoupon from "./modules/business/pages/coupons/edit";
import NotificationList from "./modules/business/pages/accountSetting/notification-list";
import { NotificationProvider } from "./modules/business/pages/hooks/useNotification";
import SubscriptionTable from "./modules/admin/subscriptionPlan/list";
import SubscriptionView from "./modules/admin/subscriptionPlan/view";
import SubscriptionEdit from "./modules/admin/subscriptionPlan/edit";
import UserSubscriptionTable from "./modules/admin/userSubscription/list";
import UserSubscriptionDetailView from "./modules/admin/userSubscription/view";
import BusinessUsersList from "./modules/business/pages/Users/List";
import BusinessUsersDetails from "./modules/business/pages/Users/View";
import BusinessReports from "./modules/business/pages/reports/reports";
import OfflinePayment from "./modules/business/pages/Users/offlinePayment";
import ManageBankAccount from "./modules/business/pages/accountSetting/manage-bank-account";
import AddBankDetails from "./modules/business/pages/accountSetting/add-bank-details";
import AccountRedirectionPage from "./modules/business/pages/accountSetting/account-redirection";
import RatingList from "./modules/admin/pages/ratings/list";
import RatingView from "./modules/admin/pages/ratings/view";
import ReferAndEarnList from "./modules/admin/pages/refer-and-earn/list";
import ReferAndEarnView from "./modules/admin/pages/refer-and-earn/detail";
import RevenueReportList from "./modules/admin/pages/reports/revenue-reports/list";
import RevenueView from "./modules/admin/pages/reports/revenue-reports/view";
import OfflinePaymentReports from "./modules/business/pages/reports/offline-payment-reports";
import UserReports from "./modules/business/pages/reports/user-reports";
import ManageSubscription from "./modules/business/pages/accountSetting/manage-subscription";
import UserEngagementReportList from "./modules/admin/pages/reports/user-engagement/list";
import RedemptionReportList from "./modules/admin/pages/reports/redemption-reports/list";
import RedemptionReportView from "./modules/admin/pages/reports/redemption-reports/view";
import SMSTemplatesTable from "./modules/admin/pages/cms/smsTemplates/list";
import SmsTempAdd from "./modules/admin/pages/cms/smsTemplates/add";
import SmsTempEdit from "./modules/admin/pages/cms/smsTemplates/edit";
import ViewSmsTemp from "./modules/admin/pages/cms/smsTemplates/view";
import NotificationListAdmin from "./modules/admin/pages/notifications/list";

const router = createBrowserRouter([
  // { path: "/inquiry", element: <Enquire /> },

  {
    path: "/",
    element: <BusinessPublicRoute component={BusinessAuthLayout} />,
    children: [
      {
        path: "",
        element: <BusinessWelcomePage />,
      },
    ],
  },

  /**ADMIN ROUTE START */
  {
    path: "admin",
    element: <PrivateRoute component={AdminLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/admin/dashboard"} />,
      },
      {
        path: "dashboard",
        element: <PrivateRoute component={Dashboard} />,
      },
      {
        path: "invoice-design",
        element: <PrivateRoute component={InvoiceDesign} />,
      },
      {
        path: "profile",
        element: <PrivateRoute component={Profile} />,
        children: [
          {
            path: "edit/:id",
            element: <PrivateRoute component={EditProfile} />,
          },
          {
            path: "change-password/:id",
            element: <PrivateRoute component={Changepassword} />,
          },
        ],
      },
      {
        /**testimonial management route start */
      },
      {
        path: "notifications/list/:pgno",
        element: <NotificationListAdmin />,
      },
      {
        path: "testimonial-management/testimonial/list/:pgno",
        element: <TestimonialTable />,
      },
      {
        path: "testimonial-management/testimonial/view/:id",
        element: <TestimonialView />,
      },
      {
        path: "testimonial-management/testimonial/add",
        element: <TestimonialAdd />,
      },
      {
        path: "testimonial-management/testimonial/:pgno/edit/:id",
        element: <TestimonialEdit />,
      },
      {
        /**testimonial management route end */
      },

      {
        /**FAQ management route start */
      },
      {
        path: "faq/list/:pgno",
        element: <PrivateRoute component={FAQTable} />,
      },
      {
        path: "faq/view/:id",
        element: <PrivateRoute component={FAQView} />,
      },
      {
        path: "faq/add",
        element: <PrivateRoute component={FAQAdd} />,
      },
      {
        path: "faq/:pgno/edit/:id",
        element: <PrivateRoute component={FAQEdit} />,
      },
      {
        /**FAQ management route end */
      },

      {
        path: "inquiry/list/:pgno",
        element: <PrivateRoute component={InquiryTable} />,
      },
      {
        path: "inquiry/view/:id",
        element: <PrivateRoute component={InquiryView} />,
      },
      {
        /**Inquiry management route end */
      },

      // Business Pages

      {
        path: "business/list/:pgno",
        element: <PrivateRoute component={BusinessList} />,
      },
      {
        path: "business/view/:id",
        element: <PrivateRoute component={BusinessView} />,
      },
      {
        path: "business/:pgno/edit/:id",
        element: <PrivateRoute component={BusinessEdit} />,
      },

      // Rating Pages

      {
        path: "rating/list/:pgno",
        element: <PrivateRoute component={RatingList} />,
      },
      {
        path: "rating/view/:id",
        element: <PrivateRoute component={RatingView} />,
      },

      // Refer and earn Pages

      {
        path: "refer-and-earn/list/:pgno",
        element: <PrivateRoute component={ReferAndEarnList} />,
      },
      {
        path: "refer-and-earn/view/:id",
        element: <PrivateRoute component={ReferAndEarnView} />,
      },

      // Revenure reports Pages

      {
        path: "reports/revenue-reports/list/:pgno",
        element: <PrivateRoute component={RevenueReportList} />,
      },
      {
        path: "reports/revenue-reports/view/:_id",
        element: <PrivateRoute component={RevenueView} />,
      },
      {
        path: "reports/users-engagement-report/list/:pgno",
        element: <PrivateRoute component={UserEngagementReportList} />,
      },
      {
        path: "reports/redemption-report/list/:pgno",
        element: <PrivateRoute component={RedemptionReportList} />,
      },
      {
        path: "reports/redemption-report/view/:_id",
        element: <PrivateRoute component={RedemptionReportView} />,
      },

      // Users Pages

      {
        path: "user/list/:pgno",
        element: <PrivateRoute component={UsersList} />,
      },
      {
        path: "user/view/:id",
        element: <PrivateRoute component={UserView} />,
      },
      {
        path: "user/edit/:id",
        element: <PrivateRoute component={UserEdit} />,
      },
      // All CMS Routes

      {
        path: "cms/pages/list/:pgno",
        element: <PrivateRoute component={PageTable} />,
      },
      {
        path: "cms/pages/add",
        element: <PrivateRoute component={PageAdd} />,
      },
      {
        path: "cms/pages/:pgno/edit/:id",
        element: <PrivateRoute component={PageEdit} />,
      },
      {
        path: "cms/pages/view/:id",
        element: <PrivateRoute component={PageView} />,
      },

      {
        path: "cms/banner/list/:pgno",
        element: <PrivateRoute component={BannerTable} />,
      },
      {
        path: "cms/banner/add",
        element: <PrivateRoute component={BannerAdd} />,
      },
      {
        path: "cms/banner/:pgno/edit/:id",
        element: <PrivateRoute component={BannerEdit} />,
      },
      {
        path: "cms/banner/view/:id",
        element: <PrivateRoute component={BannerView} />,
      },

      // {
      //   path: "cms/faq/list/:pgno",
      //   element: <PrivateRoute component={FAQTable} />,
      // },
      // {
      //   path: "cms/faq/add",
      //   element: <PrivateRoute component={FAQAdd} />,
      // },
      // {
      //   path: "cms/faq/:pgno/edit/:id",
      //   element: <PrivateRoute component={FAQEdit} />,
      // },
      // {
      //   path: "cms/faq/view/:id",
      //   element: <PrivateRoute component={FAQView} />,
      // },

      {
        path: "cms/settings",
        element: <PrivateRoute component={GlobalSettings} />,
      },

      {
        path: "cms/default-email-template/list/:pgno",
        element: <PrivateRoute component={EmailTemplatesTable} />,
      },
      {
        path: "cms/default-email-template/add",
        element: <PrivateRoute component={EmailTempAdd} />,
      },
      {
        path: "cms/default-email-template/:pgno/edit/:id",
        element: <PrivateRoute component={EmailTempEdit} />,
      },
      {
        path: "cms/default-email-template/view/:id",
        element: <PrivateRoute component={ViewEmailTemp} />,
      },

      /** Email Logs Routing End*/

      /** SMS Logs Routing start*/
      {
        path: "cms/default-sms-template/list/:pgno",
        element: <PrivateRoute component={SMSTemplatesTable} />,
      },
      {
        path: "cms/default-sms-template/add",
        element: <PrivateRoute component={SmsTempAdd} />,
      },
      {
        path: "cms/default-sms-template/:pgno/edit/:id",
        element: <PrivateRoute component={SmsTempEdit} />,
      },
      {
        path: "cms/default-sms-template/view/:id",
        element: <PrivateRoute component={ViewSmsTemp} />,
      },
      /** SMS Logs Routing End*/

      {
        /**Categories management route start */
      },
      {
        path: "manage-categories/categories/list/:pgno",
        element: <PrivateRoute component={CategoryTable} />,
      },
      {
        path: "manage-categories/categories/add",
        element: <PrivateRoute component={CategoriesAdd} />,
      },
      {
        path: "manage-categories/categories/:pgno/edit/:id",
        element: <PrivateRoute component={CategoriesEdit} />,
      },
      {
        path: "manage-categories/categories/view/:id",
        element: <PrivateRoute component={CategoriesView} />,
      },

      // Sub categories routing ending
      {
        path: "manage-categories/sub-categories/list/:pgno",
        element: <PrivateRoute component={SubCategoryTable} />,
      },
      {
        path: "manage-categories/sub-categories/add",
        element: <PrivateRoute component={SubCategoriesAdd} />,
      },
      {
        path: "manage-categories/sub-categories/:pgno/edit/:id",
        element: <PrivateRoute component={SubCategoriesEdit} />,
      },
      {
        path: "manage-categories/sub-categories/view/:id",
        element: <PrivateRoute component={SubCategoriesView} />,
      },
      // Sub categories routing ending

      // Transactions Page
      {
        path: "transactions/list/:pgno",
        element: <PrivateRoute component={TransactionsList} />,
      },

      /** subscription related route start from here */
      {
        path: "subscription/subscription-plan/list/:pgno",
        element: <PrivateRoute component={SubscriptionTable} />,
      },
      {
        path: "subscription/subscription-plan/view/:_id",
        element: <PrivateRoute component={SubscriptionView} />,
      },
      {
        path: "subscription/subscription-plan/edit/:_id",
        element: <PrivateRoute component={SubscriptionEdit} />,
      },

      {
        path: "subscription/user-subscription-plan/list/:pgno",
        element: <PrivateRoute component={UserSubscriptionTable} />,
      },
      {
        path: "subscription/user-subscription-plan/view/:_id",
        element: <PrivateRoute component={UserSubscriptionDetailView} />,
      },

      /**user subscription related route start from here */
    ],
  },
  {
    path: "admin",
    element: <AdminUnAuthLayout />,
    children: [
      { path: "login", element: <PublicRoute component={Login} /> },
      {
        path: "forget-password",
        element: <PublicRoute component={ForgotPwdPage} />,
      },
      {
        path: "otp-verification/:email",
        element: <PublicRoute component={OtpVerificationPage} />,
      },
      {
        path: "reset-password",
        // element: localStorage.getItem("validate_string") ? <PrivateRoute component={ResetPwdPage} /> : <Navigate to="/admin/login" />
        element: <PublicRoute component={ResetPwdPage} />,
      },
    ],
  },
  {
    path: "admin/complete-profile/:validate_string",
    element: <PublicRoute component={CompleteAdminProfile} />,
  },

  { path: "admin/*", element: <Error404 /> },

  /** BUSINESS ROUTE START */
  {
    path: "business",
    element: <BusinessPrivateRoute component={BusinessLayout} />,
    children: [
      {
        path: "dashboard",
        element: <BusinessPrivateRoute component={BusinessDashboard} />,
      },
      {
        path: "transactions",
        element: <BusinessPrivateRoute component={BusinessTransactions} />,
      },
      {
        path: "transactions/:transactionId",
        element: <BusinessPrivateRoute component={BusinessTransactionDetails} />,
      },
      {
        path: "users/:pgno",
        element: <BusinessPrivateRoute component={BusinessUsersList} />,
      },
      {
        path: "users/create-payment",
        element: <BusinessPrivateRoute component={OfflinePayment} />,
      },
      {
        path: "users/view/:userId",
        element: <BusinessPrivateRoute component={BusinessUsersDetails} />,
      },
      {
        path: "reports",
        element: <BusinessPrivateRoute component={BusinessReports} />,
      },
      {
        path: "user-reports",
        element: <BusinessPrivateRoute component={UserReports} />,
      },
      {
        path: "offline-transaction-reports",
        element: <BusinessPrivateRoute component={OfflinePaymentReports} />,
      },
      {
        path: "manage-bank-account",
        element: <BusinessPrivateRoute component={StripeHome} />,
      },
      {
        path: "account-setting",
        element: <BusinessPrivateRoute component={AccountSetting} />,
      },
      {
        path: "notification-list",
        element: (
          <BusinessPrivateRoute
            component={() => (
              <NotificationProvider>
                <NotificationList />
              </NotificationProvider>
            )}
          />
        ),
      },

      // {
      //   path: "change-password",
      //   element: <BusinessPrivateRoute component={ChangePassword} />,
      // },
      { path: "support", element: <BusinessPrivateRoute component={BusinessSupport} /> },
      { path: "support/faqs", element: <BusinessPrivateRoute component={FAQ} /> },
      { path: "support/ticket", element: <BusinessPrivateRoute component={CustomerTicket} /> },
      { path: "account-setting/edit-business-info", element: <BusinessPrivateRoute component={EditBusinessInfo} /> },
      { path: "account-setting/edit-business-description", element: <BusinessPrivateRoute component={EditBusinessDescription} /> },
      { path: "account-setting/add-bank-details", element: <BusinessPrivateRoute component={AddBankDetails} /> },
      { path: "account-setting/edit-business-hours", element: <BusinessPrivateRoute component={EditBusinessHours} /> },
      { path: "account-setting/edit-notification", element: <BusinessPrivateRoute component={EditNotification} /> },
      { path: "account-setting/edit-location-details", element: <BusinessPrivateRoute component={EditLocationDetails} /> },
      { path: "coupons/add", element: <BusinessPrivateRoute component={BusinessCoupons} /> },
      { path: "coupons/:pgno", element: <BusinessPrivateRoute component={ListBusinessCoupons} /> },
      { path: "coupons/view/:id", element: <BusinessPrivateRoute component={ViewBusinessCoupon} /> },
      { path: "coupons/edit/:id", element: <BusinessPrivateRoute component={EditBusinessCoupon} /> },
      { path: "*", element: <Page404 homePath="/business/dashboard" /> },
      { path: "account-setting/manage-bank-account", element: <BusinessPrivateRoute component={ManageBankAccount} /> },
      { path: "account-setting/confirmation-page/:status", element: <BusinessPrivateRoute component={AccountRedirectionPage} /> },
      { path: "account-setting/subscription", element: <BusinessPrivateRoute component={ManageSubscription} /> },
      { path: "account-setting/change-password", element: <BusinessPrivateRoute component={ChangePassword} /> },

    ],
  },
  {
    path: "business/complete-profile",
    element: <BusinessPrivateRoute component={BusinessProfileLayout} />,
    children: [
      {
        path: "business-description",
        element: (
          <BusinessPrivateRoute
            component={() => (
              <ProfileFormProvider>
                <BusinessDescription />
              </ProfileFormProvider>
            )}
          />
        ),
      },
      {
        path: "opening-hours",
        element: (
          <BusinessPrivateRoute
            component={() => (
              <ProfileFormProvider>
                <OpeningHours />
              </ProfileFormProvider>
            )}
          />
        ),
      },
      {
        path: "location-details",
        element: (
          <BusinessPrivateRoute
            component={() => (
              <ProfileFormProvider>
                <LocationDetail />
              </ProfileFormProvider>
            )}
          />
        ),
      },
    ],
  },

  /** BUSINESS AUTH ROUTE START */
  {
    path: "business",
    element: <BusinessPublicRoute component={BusinessAuthLayout} />,
    children: [
      {
        path: "",
        element: <BusinessPublicRoute component={BusinessWelcomePage} />,
      },
      {
        path: "login",
        element: <BusinessPublicRoute component={BusinessLogin} />,
      },
      {
        path: "forget-password",
        element: <BusinessPublicRoute component={BusinessForgotPwdPage} />,
      },
      {
        path: "otp-verification",
        element: <BusinessPublicRoute component={BusinessVerifyOTP} />,
      },
      {
        path: "reset-password",
        element: <BusinessPublicRoute component={BusinessResetPassword} />,
      },
      {
        path: "register",
        element: <BusinessPublicRoute component={BusinessRegister} />,
      },
      {
        path: "register-otp-verification",
        element: <BusinessPublicRoute component={BusinessRegisterVerifyOTP} />,
      },
      {
        path: "register-thanks-page",
        element: <BusinessPublicRoute component={BusinessThanksPage} />,
      },
      {
        path: "password-update-page",
        element: <BusinessPublicRoute component={PasswordUpdatePage} />,
      },
      // Optional fallback
      // { path: "*", element: <Page404 homePath="/business" /> },
    ],
  },

  {
    path: "business",
    children: [
      {
        path: "terms-and-conditions",
        element: <BusinessPublicRoute component={BusinessTermsAndConditions} />,
      },
      {
        path: "privacy-policy",
        element: <BusinessPublicRoute component={() => <PrivacyPolicy />} />,
      },
    ],
  },

  // {
  //   path: "business/register",
  //   element: <BusinessPublicRoute component={BusinessRegister} />,
  // },
]);

export default router;
